<template>
  <unified-select :render-tools='renderTools'
                  :transforms-and-source='transformsAndSource'
                  :partutil='partutil'
                  :holder-data='holderData'
                  :layers='layers'
                  :selected-layers='selectedLayers'
                  class='overflow-y-scroll'
                  @select-sticker='onSelectSticker'
                  @select-video='onSelectAnimation'
                  @select-pack='onSelectPack'
                  @select-toy='onSelectToy'
                  @select-uploaded-image='onSelectUploadedImage' />
</template>
<script>
import { cloneDeep } from 'lodash';
import Treeutil from '@/edit/tree/treeutil.js';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import UnifiedSelect from '@ui/molecules/UnifiedSelect.vue';
export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    selectedLayers: {
      type: Object,
      required: true
    },
    layers: {
      type: Object,
      required: true
    },
  },
  data() {
    const gamedata = this.partutil.gamedata.gamedata;
    if (typeof(gamedata.uploadedImages) === 'undefined') {
      this.$set(gamedata, 'uploadedImages', []);
    }
    const uploadedImages = gamedata.uploadedImages;

    return {
      mode:'image',
      uploadedImages
    }
  },
  components: {
    UnifiedSelect
  },
  methods:{
    onSelectToy({layer,toysheet,toy,position}) {
      console.log('select toy', layer, toysheet, toy, position);
     if (layer.id === 'background') {
        this.$emit("clear-layer", layer);
      }
      toy = cloneDeep(JSON.parse(toy.toy));

      const {newChildren, newComponents, newParents} = this.partutil.addToy(this.partutil.root, toy, this.partutil.selectedLayer);

      this.$emit('add-children', {
        newChildren,
        newParents,
        newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'add',
        extra: {
          type: 'toy'
        }
      });

      (this.$refs.instantViewToys||[]).forEach( (ivt) => {
        ivt.deselect();
      });

      this.$emit("mode", "chosepack");
      /*
      if (this.toyLimits[toy.id]) {
        this.toysBlocked[toy.id] = 1;
        this.selectedToy = {};
        (this.$refs.instantViewToys||[]).forEach( (ivt) => {
          ivt.deselect();
        });
      }
      */
      // TODO: hack around potential background and then drag
      // issue ?
      if (layer.id !== 'background') {
        this.$emit('select-children', {
          children:newChildren,
          parents:newParents,
          components:newComponents
        });
      }
    },
    onSelectPack({layer,toysheet,image,spritesheet,position}) {
      if (layer.id === 'background') {
        this.$emit("clear-layer", layer);
      }

      const newComponent = ComponentsDb.types.sprite.createNew();
      if (spritesheet) {
        Object.assign(newComponent, {
          atlas:spritesheet.id,
          texture:image.name,
          sprite:image.name,
          firstLoad:true
        });
      } else {
        Object.assign(newComponent, {
          sprite:image.id,
          firstLoad:true
        });
      }

      this.partutil.selectLayer(layer);
      const {
        newChildren,
        newParents,
        newComponents,
      } = this.partutil.addChildren([this.partutil.root], newComponent);

      newChildren.forEach( (child) => {
        child.transform.pos.x = position.x;
        child.transform.pos.y = position.y;
      });

      this.newChildren = newChildren;
      this.newParents = newParents;
      this.newComponents = newComponents;

      //this.addChildren({newChildren, newParents, newComponents});
      this.$emit('add-children', {
        newChildren,
        newParents,
        newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'add',
        extra: {
          type: spritesheet ? 'spritesheet' : 'image'
        }
      });

      const treeutil = new Treeutil(this.partutil.from);
      toysheet.autotoys.forEach( ({name,components,transform}) => {
        (components||[]).forEach( (c) => {
          const component = JSON.parse(c);
          const newComponent = ComponentsDb.createComponent(component.type, component);
          Object.assign(newComponent, component);
          const {addedComponents,addedLinks} = treeutil.addComponentWithLinkData(newComponents[0], {name:'link'}, newComponent);
        });

        if (typeof(transform) !== 'undefined' && transform !== null) {
          transform = JSON.parse(transform);
          const addedTransform = newChildren[0];
          if (transform.scalemethod) {
            this.renderTools.addOnReadyEvent(addedTransform, (holder) => {
              //this.renderTools.addToRunBatch( () => {
              console.log('hav scalemethod', transform.scalemethod);
              if (transform.scalemethod === 'cover') {
                holder.scaleCover();
              } else if (transform.scalemethod === 'contain') {
                holder.scaleContain();
              }
              this.renderTools.addToRunBatch( () => {
                this.renderTools.addToUpdateBatch(holder);
              });
            });
          }

          if (transform.pos) {
            addedTransform.transform.pos.x = transform.pos.x;
            addedTransform.transform.pos.y = transform.pos.y;
          }
        }
      });

      this.$emit("mode", "chosepack");
      /*
      this.$emit('position-children', {
        children:newChildren,
        parents:newParents
      });
      */

      // TODO: hack around potential background and then drag
      // issue ?
      if (layer.id !== 'background') {
        this.$emit('select-children', {
          children:newChildren,
          parents:newParents,
          components:newComponents
        });
      }

    },
    onAddChildren({newChildren, newParents, newComponents}) {
      console.log('select-pack');
      this.$emit('add-children', {
        newChildren,
        newParents,
        newComponents
      });
    },
    onSelectSticker(animation) {
      console.log('add animation', animation)
      const layer = {
        id:"toy",
        name:"Toy",
        zindex:2,
        projection:"orthogonal",
        direction:"rightdown"
      }

      const {newChildren, newComponents, newParents, sprite} = this.partutil.addSprite(this.partutil.root, layer);
      console.log('i added a sprite', sprite);
      sprite.anim = true;
      sprite.anims = [{
        frames:JSON.parse(animation.frames),
        loopByDefault: animation.loopByDefault,
        timePerFrame: animation.timePerFrame
      }]
      sprite.atlas = sprite.anims[0].frames[0].atlas;
      sprite.sprite = sprite.anims[0].frames[0].texture;
      sprite.texture = sprite.anims[0].frames[0].texture;
      console.log('have sprite', sprite);

      newChildren.forEach( (child) => {
        child.transform.scale.x = 1.4;
        child.transform.scale.y = 1.4;
      });
      //sprite.anims = JSON.parse(animation.frames);
      //sprite.loopByDefault = animation.loopByDefault;
      //sprite.timePerFrame = animation.timePerFrame;

      this.onAddChildren({
        newChildren,
        newParents,
        newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'add',
        extra: {
          type: 'animation'
        }
      });

      this.$emit('done');
    },
    onSelectAnimation(animation) {
      console.log('add animation', animation)
      const layer = {
        id:"default",
        zindex:1,
        projection:"orthogonal",
        direction:"rightdown"
      }

      const {newChildren, newComponents, newParents, sprite} = this.partutil.addSprite(this.partutil.root, layer);
      console.log('i added a sprite', sprite);
      sprite.anim = true;
      sprite.anims = [{
        frames:JSON.parse(animation.frames),
        loopByDefault: animation.loopByDefault,
        timePerFrame: animation.timePerFrame
      }]
      sprite.atlas = sprite.anims[0].frames[0].atlas;
      sprite.sprite = sprite.anims[0].frames[0].texture;
      sprite.texture = sprite.anims[0].frames[0].texture;
      console.log('have sprite', sprite);

      newChildren.forEach( (child) => {
        child.transform.scale.x = 1.4;
        child.transform.scale.y = 1.4;
      });
      //sprite.anims = JSON.parse(animation.frames);
      //sprite.loopByDefault = animation.loopByDefault;
      //sprite.timePerFrame = animation.timePerFrame;

      this.onAddChildren({
        newChildren,
        newParents,
        newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'add',
        extra: {
          type: 'video'
        }
      });

      this.$emit('done');

    },
    onSelectUploadedImage({id}) {
      console.log('upload le image', id);
      const layer = {
        id:'default',
        name:'Foreground',
        zindex:1,
        projection:'orthogonal',
        direction:'rightdown'
      }
      const position = {
        x: 0,
        y: 0
      }
      const {newChildren,newParents,newComponents} = this.partutil.addImageFromSpritesheet({
        layer,
        image:{id},
        position,
      });


      this.$emit('add-children', {
        newChildren,
        newParents,
        newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'uploaded',
        extra: {
          id
        }
      });

        const component = newComponents[0];
        const transform = newChildren[0];

        this.renderTools.addOnReadyEvent(newChildren[0], (holder) => {
          holder.scaleContain();
          this.renderTools.addToRunBatch( () => {
            this.renderTools.addToUpdateBatch(holder);
          });
        });


    },

  },
}
</script>
<style>

</style>
